import request from 'config/apiConfig';

export const getCTAByMarketer = (payload: {}) => {
  return request.get(`conversion/ctas/marketer`, {
    params: { sort: 'created,desc' }
  });
};

export const getConversionDetails = (payload: any) => {
  return request.get(`/conversion/conversions/${payload?.data.id}`);
};

export const getConversionsByMarketer = (payload: {}) => {
  return request.get(`conversion/conversions`, {
    params: { sort: 'created,desc' }
  });
};

export const postConversion = (payload: any) => {
  return request.post('conversion/conversions', payload);
};

export const updateConversion = ({ id, ...payload }: any) => {
  return request.put(`conversion/conversions/${id}/info`, payload.data);
};

export const postConversionAssets = (id: string, formData: FormData) => {
  return request.put(`content/assets/conversion/${id}`, formData);
};

export const getConversionFormType = (payload: any) => {
  return request.get(`/conversion/forms/all`);
};

export const postFormConversion = (id: string, payload: any) => {
  return request.post(`conversion/conversions/form?id=${id}`, payload);
};

export const putFormConversion = (formId: string, conversionId: any) => {
  return request.put(`conversion/conversions/${conversionId}/form`, { form: formId });
};

export const deleteConversion = (conversionId: string) => {
  return request.delete(`conversion/conversions/${conversionId}`);
};
